// RoundedTick.tsx
import { Box } from '@mui/material';
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';
import DoneIcon from '@mui/icons-material/Done';
import RoundedTickSVG from '../assets/images/RoundedTick';
import RoundedSVG from '../assets/images/Rounded';

interface RoundedTickProps {
  isTrigger?: boolean;
}

const ToggleTick: React.FC<RoundedTickProps> = ({ isTrigger = false }) => (
  <Box sx={{ position: 'relative', display: 'inline-flex' }}>
    {isTrigger ? <RoundedTickSVG style={{ marginRight: '0.5rem' }} /> : <RoundedSVG style={{ marginRight: '0.5rem' }} />}
  </Box>
);

export default ToggleTick;